import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    secondary: {
      main: "#FF8A00",
    },
  },
});

export default theme;
